import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";
import { activityTimelineData, monthlyDropdownList } from "../../../Data/Dashboard/Default";
import { Badges, H5, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

const ActivityTimeline = () => {
  return (
    <Col xl="4" md="6" className="xl-50 lg-order-1 md-order-1 box-col-6">
      <Card className="our-todolist">
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Activity Timeline"} />
        <CardBody>
          <div className="activity-timeline todo-timeline">
            {activityTimelineData.map((item, index) => (
              <div className="d-flex" key={index}>
                <div className="activity-line" />
                {item.isNew ? (
                  <div className="activity-dot-secondary" />
                ) : (
                  <div className="activity-dot-primary" />
                )}
                <div className="flex-grow-1">
                  <P className="mt-0 todo-font">
                    <span className="font-primary">{item.date} </span>
                    Today
                    {item.isNew && (
                      <Badges color="primary" className="ms-2">New</Badges>
                    )}
                  </P>
                  {index === 0 ? (
                    <div className="d-flex mt-0">
                      <Image className="img-fluid img-30" src={dynamicImage(`dashboard/todo.png`)} alt="image" />
                      <div className="flex-grow-1">
                        <H5>{item.title}</H5>
                        {item.description && (<P className="mb-0">{item.description}</P>)}
                      </div>
                    </div>
                  ) :
                    <>
                      <H5>{item.title}</H5>
                      {item.description && (<P className="mb-0">{item.description}</P>)}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ActivityTimeline;